import { useStore } from '@hooks/useStore';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { useGetBrandData } from '@hooks/useGetBrandData';
import { PageHeader } from '@components/Core/PageHeader';
import { AppLoader } from '@components/Core/AppLoader';
import CatalogueForm from '@forms/CatalogueForm';
import { CataloguesTransFields } from '@pages/Catalogues/types';
import { cataloguesTranslations } from '@pages/Catalogues/translations';

function AddCatalogue() {
  const {
    brandsStore: { brand },
  } = useStore();

  const { t } = useMyTranslations<Extract<CataloguesTransFields, 'addCatalogue'>>([
    cataloguesTranslations.name,
  ]);

  const { isFetching, text } = useGetBrandData(
    t('addCatalogue', { ns: cataloguesTranslations.name })
  );

  return (
    <div className="page-container">
      <PageHeader text={text} />
      {isFetching ? <AppLoader /> : brand && <CatalogueForm brandId={brand.id} />}
    </div>
  );
}

export default AddCatalogue;
